export const getWeekOption = (distData: any) => {
    if (!distData) return {};
    const days = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
    const data = Array.from({ length: 7 }, (_, i) => distData.week_dist[i] || 0);

    return {
        title: {
            text: '按周分布',
            textStyle: { fontSize: 14, fontWeight: 600, color: '#1f2937' },
            left: 'center'
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e5e7eb',
            textStyle: { color: '#374151' }
        },
        grid: { left: '3%', right: '4%', bottom: '10%', top: '18%', containLabel: true },
        xAxis: {
            type: 'category',
            data: days,
            axisLabel: { color: '#6b7280' },
            axisLine: { lineStyle: { color: '#e5e7eb' } },
            axisTick: { show: false }
        },
        yAxis: {
            type: 'value',
            axisLabel: { color: '#6b7280' },
            splitLine: { lineStyle: { color: '#f3f4f6', type: 'dashed' } },
            axisLine: { show: false }
        },
        series: [{
            name: '订单量',
            type: 'bar',
            data,
            barMaxWidth: 40,
            itemStyle: {
                color: {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: '#34d399' },
                        { offset: 1, color: '#a7f3d0' }
                    ]
                },
                borderRadius: [4, 4, 0, 0]
            }
        }]
    };
};
